module.exports = __webpack_public_path__ + "img/img_banner_fengxianpinggu.b1a039b2.png";